var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleStats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9987 10.832H1.66536C1.16536 10.832 0.832031 11.1654 0.832031 11.6654V18.332C0.832031 18.832 1.16536 19.1654 1.66536 19.1654H4.9987C5.4987 19.1654 5.83203 18.832 5.83203 18.332V11.6654C5.83203 11.1654 5.4987 10.832 4.9987 10.832ZM18.332 7.4987H14.9987C14.4987 7.4987 14.1654 7.83203 14.1654 8.33203V18.332C14.1654 18.832 14.4987 19.1654 14.9987 19.1654H18.332C18.832 19.1654 19.1654 18.832 19.1654 18.332V8.33203C19.1654 7.83203 18.832 7.4987 18.332 7.4987ZM11.6654 0.832031H8.33203C7.83203 0.832031 7.4987 1.16536 7.4987 1.66536V18.332C7.4987 18.832 7.83203 19.1654 8.33203 19.1654H11.6654C12.1654 19.1654 12.4987 18.832 12.4987 18.332V1.66536C12.4987 1.16536 12.1654 0.832031 11.6654 0.832031Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleStats);
export default __webpack_public_path__ + "static/media/GoogleStats.0a956425.svg";
export { ForwardRef as ReactComponent };